import React from 'react';
import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  { path: '/', label: 'Portal', exact: true },
  { path: '/security', label: 'Security', badge: '' },
  { path: '/performance', label: 'Performance' },
  { path: '/devplatform', label: 'Dev Platform' },
  { path: '/ai', label: 'AI', badge: 'NEW' },
  { path: '/saas', label: 'SSL for SaaS' },
];

const CloudflareLogo = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="cf-logo">
    <rect width="28" height="28" rx="6" fill="#F6821F"/>
    <path d="M18.9 16.4c.1-.3.1-.6 0-.9l-1-2.4c-.3-.7-1-.7-1.3 0l-.5 1.2c-.2.4-.6.7-1.1.7h-6c-.3 0-.5.2-.5.5v.5c0 .3.2.5.5.5h9.4c.3 0 .5-.2.5-.5v-.6z" fill="white"/>
    <path d="M21 13.5c-.1-.2-.2-.3-.4-.3h-1.2c-.2 0-.3.1-.4.3l-.8 1.9c-.1.3 0 .5.3.5h2.8c.3 0 .4-.2.3-.5l-.6-1.9z" fill="white"/>
  </svg>
);

export default function Nav() {
  return (
    <nav className="nav">
      <NavLink to="/" className="nav-brand">
        <CloudflareLogo />
        Demo Portal
      </NavLink>
      <div className="nav-links">
        {NAV_ITEMS.map(({ path, label, badge }) => (
          <NavLink
            key={path}
            to={path}
            end={path === '/'}
            className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
          >
            {label}
            {badge && <span className="nav-badge">{badge}</span>}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
